import {
  GAME_DASHBOARD_CARD_CREATE_REQUEST,
  GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS,
  GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR,
} from "../actionTypes/type";

const initialState = {
  data: null,
  isLoading: false
};

const gameDashboardCardCreateReducer = (state = initialState, action) => {
  let object;

  switch (action.type) {
    case GAME_DASHBOARD_CARD_CREATE_REQUEST:
      object = {
        ...state,
        isLoading: true
      };
      break;

    case GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR:
      object = {
        ...state,
        isLoading: false
      };
      break;

    case GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS:
      object = {
        ...state,
        data: action.payload,
        isLoading: false
      };
      break;

    default:
      object = state;
      break;
  }
  return object;
}

export default gameDashboardCardCreateReducer;
